import { render } from "./AddDistancePage.vue?vue&type=template&id=9bdf4ce6&ts=true"
import script from "./AddDistancePage.vue?vue&type=script&lang=ts"
export * from "./AddDistancePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__